<template>
  <div
      v-if="activatedMapColorizer"
      class="d-flex flex-column rounded-1 bg-theme-transparent gmb-block--floating-box"
  >
    <GmbSection
        collapseIsVisibleByDefault
        :displayLevel="1"
        isCollapsible
        lockHeader
        :title="individualCount ? activatedMapColorizer.label : 'Légende'"
    >
      <template #picto>
        <FdText colorTheme4 fa>
          <i class="fas fa-palette"/>
        </FdText>
      </template>

      <template v-if="individualCount" #infoSticker>
        <GmbSticker :text="activatedMapColorizerCriteria.length.toString()"/>
      </template>

      <template v-if="individualCount && activatedMapColorizerCriteria.length">
        <GmbRow
            v-for="(
            activatedMapColorizerCriterion, i
          ) in activatedMapColorizerCriteria"
            isStickerOffsetWidthFixed
            :key="i"
        >
          <template #picto>
            <GmbColorPalettePicto
                :color="getColorForCriterion(activatedMapColorizerCriterion)"
            />
          </template>

          <FdLevelBar
              :color="getColorForCriterion(activatedMapColorizerCriterion)"
              :label="activatedMapColorizerCriterion.label"
              :percentage="
              calculatePercentage(
                activatedMapColorizerCriterion.individualCount
              )
            "
          />

          <template #infoSticker>
            <GmbIndividualSticker
                :individualCount="activatedMapColorizerCriterion.individualCount"
            />
          </template>
        </GmbRow>
      </template>

      <FdText v-else colorWhite tag="span">Aucun individu</FdText>
    </GmbSection>
  </div>
</template>

<script>
import FdLevelBar from "@/flexdesign/LevelBar";
import FdText from "@/flexdesign/Text";

import GmbColorPalettePicto from "@/widgets/ColorPalettePicto";
import GmbIndividualSticker from "@/widgets/IndividualSticker";
import GmbRow from "@/widgets/Row";
import GmbSection from "@/widgets/Section";
import GmbSticker from "@/widgets/Sticker";

export default {
  name: "GmbMapLegend",

  components: {
    FdLevelBar,
    FdText,
    GmbColorPalettePicto,
    GmbIndividualSticker,
    GmbRow,
    GmbSection,
    GmbSticker,
  },

  data() {
    return {};
  },

  props: {
    activatedMapColorizer: Object,
    activatedMapOptionSlugs: Array,
  },

  computed: {
    activatedMapColorizerCriteria() {
      if (this.activatedMapColorizer.identifier == "organization-identity") {  // Special value in mapColorizerTree!

        /* We DO NOT care about other "hide-all-organizations" options here, we still let all legends if it's enabled */

        if (this.isHideEmptyOrganizationsMapOptionActivated)
          return this.activatedMapColorizer.criteria.filter(
              (activatedMapColorizerCriteria) =>
                  activatedMapColorizerCriteria.individualCount
          );

      }

      return this.activatedMapColorizer.criteria;
    },

    individualCount() {
      let total = 0;

      this.activatedMapColorizer.criteria.forEach((criterion) => {
        total += criterion.individualCount;
      });

      return total;
    },

    isHideEmptyOrganizationsMapOptionActivated() {
      return this.activatedMapOptionSlugs.includes("hide-empty-organizations");
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    calculatePercentage(individualCount) {
      return !this.individualCount
          ? 0
          : Math.abs(Math.round((individualCount / this.individualCount) * 100));
    },
    getColorForCriterion(activatedMapColorizerCriterion) {
      return this.activatedMapColorizer.colorMapper[
          activatedMapColorizerCriterion[
              this.activatedMapColorizer.criteriaSlug
              ]
          ]
    },
    getMapLegendSummary() {

      let legendItems = [];
      for (const activatedMapColorizerCriterion of this.activatedMapColorizerCriteria) {
        legendItems.push([
          activatedMapColorizerCriterion.label,
          this.getColorForCriterion(activatedMapColorizerCriterion),
          activatedMapColorizerCriterion.individualCount,
          this.calculatePercentage(activatedMapColorizerCriterion.individualCount)
        ]);
      }

      return {
        map_legend_label: this.activatedMapColorizer.label,
        map_legend_items: legendItems,
      }
    },
  },
};
</script>

<style lang="scss"></style>
